import React, { Component } from 'react'
import PropTypes from 'prop-types'

import is from '@sindresorhus/is'

import { numberType, unit } from '../propTypes'
import { unitMap } from '../utils'

const currencyFormatter = new Intl.NumberFormat(
  undefined, // Use default locale
  {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }
)

const integerFormatter = new Intl.NumberFormat(
  undefined, // Use default locale
  {
    maximumFractionDigits: 0,
  }
)

const numberFormatter = new Intl.NumberFormat(
  undefined, // Use default locale
  {
    maximumFractionDigits: 2,
  }
)

export default class Total extends Component {
  static propTypes = {
    label: PropTypes.node.isRequired,
    type: numberType.isRequired,
    unit,
    value: PropTypes.number,
  }

  render() {
    const {
      label,
      type,
      unit,
      value,
    } = this.props

    let displayValue = value

    if (is.number(value)) {
      if (is.nan(value)) {
        displayValue = null
      } else {
        switch (type) {
          case 'area':
            if (unit) {
              displayValue = `${numberFormatter.format(value)} ${unitMap[unit]}`
            } else {
              displayValue = null
            }
            break;
          case 'area-large':
            if (unit) {
              displayValue = `${numberFormatter.format(value)} ${unitMap[`${unit}-large`]}`
            } else {
              displayValue = null
            }
            break;
          case 'currency':
            displayValue = currencyFormatter.format(value)
            break;
          case 'integer':
            displayValue = integerFormatter.format(value)
            break;
          case 'number':
            displayValue = numberFormatter.format(value)
            break;
          default:
            // Leave displayValue as value verbatim I guess...
        }
      }
    }

    if (displayValue == null) {
      return null
    }

    return (
      <div className='calculation-results__item'>
        {displayValue}
        {label && (
          <div className='calculation-results__label'>{label}</div>
        )}
      </div>
    )
  }
}
